import React from 'react'
import { Box, ButtonPrimary } from 'front-end/src/components'
import './CampaignBanner.less'
import striptags from 'striptags'
import { IImageVariant } from '../../../../../../types/CoverImage'
import { DangerouslySetInnerHTML } from 'front-end/src/utils/DangerouslySetInnerHTML'
import { getQuillStyle } from 'front-end/src/components/common/quill/EditorQuill'

export interface ICampaignBannerProps {
  buttonLink: string
  buttonText: string
  header: string
  text: string | null | undefined
  coverImageSrc: string | null
  coverImageBase64?: string | null
  coverImageVariants: IImageVariant[]
  onButtonClick?: () => Promise<any>
  isPreview?: boolean
}

function campaignBannerImageSrcSet(
  coverImageVariants: IImageVariant[]
): string {
  return coverImageVariants
    .filter((imageVariant) => !(imageVariant.cdnUrl.match(/\.gif$/) !== null))
    .map((imageVariant) => {
      const width = imageVariant.size_key && imageVariant.size_key.split('x')[0]
      return `${imageVariant.cdnUrl} ${width}w`
    })
    .join(', ')
}

function campaignBannerImageSizes(coverImageVariants: IImageVariant[]): string {
  if (!coverImageVariants.length) {
    return ''
  }
  return [
    '(min-width: 540px) 94vw',
    '(min-width: 667px) 632px',
    '(min-width: 1024px) 964px',
    '(min-width: 1500px) 1296px',
    '100vw'
  ].join(', ')
}

function campaignBannerResponsiveImages(coverImageVariants: IImageVariant[]): {
  srcSet: string
  sizes: string
} {
  return {
    srcSet: campaignBannerImageSrcSet(coverImageVariants),
    sizes: campaignBannerImageSizes(coverImageVariants)
  }
}

export const CampaignBanner: React.FC<ICampaignBannerProps> = (props) => {
  const onButtonClick = () => {
    const promise = props.onButtonClick
      ? props.onButtonClick()
      : Promise.resolve()
    promise.finally(() => {
      if (props.buttonLink) {
        if (props.isPreview) {
          window.open(props.buttonLink, '_blank')
        } else {
          window.location.href = props.buttonLink // we don't want to use navigateTo because these link can be outside loop
        }
      }
    })
  }

  const { srcSet, sizes } = campaignBannerResponsiveImages(
    props.coverImageVariants
  )

  return (
    <div className="CampaignBanner">
      <div className="CampaignBanner__inner" onClick={onButtonClick}>
        {props.coverImageBase64 && <img src={props.coverImageBase64} />}
        {props.coverImageSrc && (
          <img src={props.coverImageSrc} srcSet={srcSet} sizes={sizes} />
        )}
        <div className="CampaignBanner__content">
          <div className="CampaignBanner__text">
            <h1>{props.header}</h1>
            {props.text && striptags(props.text) && (
              <Box css={getQuillStyle('ql-editor')} className="ql-editor">
                <DangerouslySetInnerHTML content={props.text} />
              </Box>
            )}
          </div>
          <div className="CampaignBanner__cta">
            <ButtonPrimary className="large">{props.buttonText}</ButtonPrimary>
          </div>
        </div>
      </div>
    </div>
  )
}
